export const createIdempotencyKey = (prefix = "web") => {
  const randomValue = window.crypto?.randomUUID?.()
    || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  return `${prefix}:${randomValue}`;
};

export const isMutationMethod = (method = "GET") =>
  ["POST", "PUT", "PATCH", "DELETE"].includes(String(method).toUpperCase());
